import ApexCharts from "apexcharts";

export default {
  Sparkline: {
    mounted() {
      const finalValues = JSON.parse(this.el.dataset.values);
      this.minValue = Math.min(...finalValues);
      this.maxValue = Math.max(...finalValues);

      this.colorStart = this.el.dataset.colorStart;
      this.colorEnd = this.el.dataset.colorEnd;

      this.values = finalValues;

      const chartEl = document.createElement("div");
      this.el.appendChild(chartEl);

      this.chart = new ApexCharts(chartEl, this.options());
      this.chart.render();
    },

    options() {
      return {
        chart: {
          type: "line",
          toolbar: { show: false },
          height: this.el.clientHeight,
          animations: {
            enabled: false,
            easing: "linear",
            dynamicAnimation: {
              speed: 500,
            },
          },
          sparkline: {
            enabled: true,
          },
        },
        markers: {
          discrete: [
            {
              seriesIndex: 0,
              dataPointIndex: this.values.length - 1,
              size: 1,
              fillColor: "var(--color-brand-primary)",
              strokeColor: "var(--color-brand-primary)",
            },
          ],
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 2,
        },
        fill: {
          type: "gradient",
          gradient: {
            colorStops: [
              {
                offset: 0,
                color: this.colorStart,
              },
              {
                offset: 100,
                color: this.colorEnd,
              },
            ],
          },
        },
        colors: [this.colorStart],

        series: [
          {
            name: "metric",
            data: this.values,
          },
        ],
        yaxis: {
          stepSize: 1,
        },
        tooltip: {
          enabled: false,
        },
      };
    },
  },
};
